export enum Interval {
  TWO_WEEKS = 'INTERVAL_SELECTION_TWO_WEEKS',
  ONE_MONTH = 'INTERVAL_SELECTION_ONE_MONTH',
  THREE_MONTHS = 'INTERVAL_SELECTION_THREE_MONTHS',
  SIX_MONTHS = 'INTERVAL_SELECTION_SIX_MONTHS',
  TWELVE_MONTHS = 'INTERVAL_SELECTION_TWELVE_MONTHS',
  CUSTOM = 'INTERVAL_CUSTOM',
}
